<template>
  <div class="page-container">
    <div class="row ml-1">
      <h4 class="mb-4 mr-2">Lista szablonów</h4>
      <div>
        <b-button size="sm" @click="addTemplate" v-if="isSuperAdmin">
          <span data-feather="plus"></span>
          Nowy
        </b-button>
      </div>
    </div>
    <b-table
      :items="doctorsTable.items"
      :fields="doctorsTable.fields"
      :sort-by.sync="doctorsTable.sortBy"
      :sort-desc.sync="doctorsTable.sortDesc"
      show-empty
      stacked="md"
      :current-page="doctorsTable.currentPage"
      :per-page="doctorsTable.perPage"
    >
      <template v-slot:cell(api_keys)="{ item }">
        {{
          JSON.parse(item.api_keys)
            .map(key => allowedApiKeys[key])
            .join(', ')
        }}
      </template>
      <template v-slot:cell(actions)="row">
        <b-button-group>
          <b-button class="btn-primary mr-1" size="sm" @click="editTemplate(row)">Edycja</b-button>
          <b-button class="btn-primary mr-1" size="sm" @click="editTemplate(row)">Podgląd</b-button>
          <b-button class="btn-danger" size="sm" @click="deleteTemplate(row)" v-if="isSuperAdmin"
            >Usuń</b-button
          >
        </b-button-group>
      </template>
    </b-table>
    <b-row>
      <b-col md="12" class="my-1">
        <b-pagination
          v-model="doctorsTable.currentPage"
          :total-rows="doctorsTable.items.length"
          :per-page="doctorsTable.perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'All',
  async mounted() {
    const vm = this
    await vm.fetchAllowedApiKeys()
    vm.listTemplates()
  },
  data() {
    return {
      doctorsTable: {
        currentPage: 1,
        perPage: 10,
        sortBy: 'name',
        sortDesc: false,
        fields: [
          { key: 'custom_name', label: 'Nazwa' },
          { key: 'api_keys', label: 'Lokalizacje' },
          { key: 'type', label: 'Typ', sortable: true },
          { key: 'created_at', label: 'Data utworzenia', sortable: true },
          { key: 'updated_at', label: 'Data ostatniej edycji', sortable: true },
          { key: 'actions', label: 'Akcje' }
        ],
        items: []
      },
      allowedApiKeys: {}
    }
  },
  computed: {
    isSuperAdmin() {
      return this.$store.state.userInfo.account_type === 'super_admin'
    }
  },
  methods: {
    async fetchAllowedApiKeys() {
      const vm = this
      return vm.$http.post('e-zacma/get-allowed-api-keys').then(response => {
        const apiKeys = response.data
        // eslint-disable-next-line no-restricted-syntax
        for (const key of apiKeys) {
          vm.allowedApiKeys[key.api_key] = key.name
        }
      })
    },
    listTemplates() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'listDoctors')
      vm.$http.post('e-zacma/template/all').then(response => {
        vm.doctorsTable.items = response.data
        vm.$store.commit('removePageLoaderEvent', 'listDoctors')
      })
    },
    editTemplate(row) {
      this.$router.push({ name: 'e-zacma-template-modify', params: { id: row.item.id } })
    },
    deleteTemplate(row) {
      const vm = this
      vm.$bvModal
        .msgBoxConfirm(
          `Czy na pewno chcesz usunąć szablon "${row.item.custom_name}". Wynik tej operacji jest permanentny.`,
          {
            okVariant: 'danger',
            okTitle: 'Tak',
            cancelTitle: 'Nie',
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(decision => {
          if (decision) {
            vm.$store.commit('addPageLoaderEvent', 'delete-consultant')
            // eslint-disable-next-line camelcase
            const { id, user_id } = row.item
            vm.$http
              .post('e-zacma/template/delete', { id, user_id })
              .then(() => {
                vm.listTemplates()
                vm.$toast.success({
                  message: `Szablon "${row.item.custom_name}" został skasowany.`
                })
              })
              .catch(e => vm.$error())
              .finally(() => {
                vm.$store.commit('removePageLoaderEvent', 'delete-consultant')
              })
          }
        })
    },
    addTemplate() {
      this.$router.push({ name: 'e-zacma-template-create' })
    }
  }
}
</script>

<style scoped></style>
